import { useState } from "react";
import { useAuthStore } from "../../../store/auth.store";
import { PartnerApi } from "../../../api/partner.api";
import { useTranslation } from "../../../hooks/useTranslation";

export default function DealChangeStateForm({ handleClose, deal, callback }) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [submitter, setSubmitter] = useState(null);
  const token = useAuthStore((state) => state.token);

  const changeDealState = (event) => {
    event.preventDefault();

    if (submitter == null) {
      setError(t("deals.mustSendViaButton"));
      return;
    }

    const formData = new FormData(event.target);
    setError(null);

    const data = {
      deal_id: deal.deal_id,
      description: formData.get("description"),
      deal_new_state_id: submitter
    };

    const result = PartnerApi.dealChange({
      token,
      data: data,
    });
    result
      .then((result) => {
        if ("error" in result) {
          setError(result.error);
          return;
        }

        if ("deal_id" in result) {
          callback();
          handleClose();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return false;
  };

  return (
      <form onSubmit={(e) => changeDealState(e)}>
        {error && <p className="alert alert-danger">{error}</p>}

        <div className="mb-10">
          <label className="form-label">{t("deals.confirmationNote")}</label>
          <textarea
              name="description"
              className="form-control form-control-solid"
          />
        </div>


        <div className="d-flex justify-content-between gap-2">

          <button
              type="submit"
              onClick={() => setSubmitter(1)}
              className="btn btn-sm btn-success"
          >
            {t("deals.confirmRegistration")}
          </button>
          <button
              type="submit"
              onClick={() => setSubmitter(0.5)}
              className="btn btn-sm btn-warning"
          >
            {t("deals.requestAdditionalInfo")}
          </button>
          <button
              type="submit"
              onClick={() => setSubmitter(-1)}
              className="btn btn-sm btn-danger"
          >
            {t("deals.rejectRegistration")}
          </button>
        </div>
      </form>
  );
}
